<div class="w-full space-y-6">

  <!-- Page Header -->
  <div class="flex items-center justify-between pb-4 border-b border-slate-200">
    <div class="flex items-center gap-3">
      <div class="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center">
        <mat-icon class="text-slate-600">group_add</mat-icon>
      </div>
      <div>
        <h2 class="text-sm font-bold tracking-widest uppercase text-slate-800">
          Customer Onboarding
        </h2>
        <p class="text-xs text-slate-500 font-medium mt-0.5">
          Manage customer details and services
        </p>
      </div>
    </div>
  </div>

  <!-- FORM CARD -->
  <div class="bg-white rounded-lg shadow border border-slate-200 px-6 py-4">

    <form #customerForm="ngForm" (ngSubmit)="lFN_SubmitCustomer(customerForm)">

      <div class="grid grid-cols-1 md:grid-cols-5 gap-4">

        <!-- Customer Name -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Customer Name</mat-label>
          <mat-icon matPrefix class="text-slate-500">person</mat-icon>
          <input matInput name="customerName" [(ngModel)]="l_formDataCustomer.customerName" required maxlength="50"
            pattern="^[A-Za-z ]+$" #customerName="ngModel" />
          <mat-error *ngIf="customerForm.submitted && customerName.invalid">
            Alphabets & spaces only (max 50)
          </mat-error>
        </mat-form-field>

        <!-- SMS Customer Name -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>SMS Customer Name</mat-label>
          <mat-icon matPrefix class="text-slate-500">person</mat-icon>
          <input matInput name="smsCustomerName" [(ngModel)]="l_formDataCustomer.smsCustomerName" required
            maxlength="20" pattern="^[A-Za-z ]+$" #smsCustomerName="ngModel" />
          <mat-error *ngIf="customerForm.submitted && smsCustomerName.invalid">
            Alphabets & spaces only (max 20)
          </mat-error>
        </mat-form-field>

        <!-- Primary Mobile -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Primary Mobile No</mat-label>
          <mat-icon matPrefix class="text-slate-500">phone</mat-icon>
          <input matInput name="primaryMobileNo" [(ngModel)]="l_formDataCustomer.primaryMobileNo" required
            pattern="^[0-9]{10,15}$" minlength="10" maxlength="15" #primaryMobileNo="ngModel" />
          <mat-error *ngIf="customerForm.submitted && primaryMobileNo.invalid">
            10–15 digits only
          </mat-error>
        </mat-form-field>

        <!-- Secondary Mobile -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Secondary Mobile No</mat-label>
          <mat-icon matPrefix class="text-slate-500">phone_android</mat-icon>
          <input matInput name="secondaryMobileNo" [(ngModel)]="l_formDataCustomer.secondaryMobileNo"
            pattern="^[0-9]{10,15}$" minlength="10" maxlength="15" #secondaryMobileNo="ngModel" />
          <mat-error *ngIf="customerForm.submitted && secondaryMobileNo.invalid">
            10–15 digits only
          </mat-error>
        </mat-form-field>

        <!-- City -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>City</mat-label>
          <mat-icon matPrefix class="text-slate-500">location_city</mat-icon>
          <input matInput name="city" [(ngModel)]="l_formDataCustomer.city" required maxlength="20"
            pattern="^[A-Za-z ]+$" #city="ngModel" />
          <mat-error *ngIf="customerForm.submitted && city.invalid">
            Alphabets only (max 20)
          </mat-error>
        </mat-form-field>

        <!-- Address -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Address</mat-label>
          <mat-icon matPrefix class="text-slate-500">home</mat-icon>
          <textarea matInput rows="1" class="resize-none" name="address" [(ngModel)]="l_formDataCustomer.address"
            required maxlength="100" #address="ngModel"></textarea>
          <mat-error *ngIf="customerForm.submitted && address.invalid">
            Address is required
          </mat-error>
        </mat-form-field>

        <!-- Pincode -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Pincode</mat-label>
          <mat-icon matPrefix class="text-slate-500">pin</mat-icon>
          <input matInput name="pincode" [(ngModel)]="l_formDataCustomer.pincode" required pattern="^[0-9]{6}$"
            maxlength="6" #pincode="ngModel" />
          <mat-error *ngIf="customerForm.submitted && pincode.invalid">
            6 digit pincode required
          </mat-error>
        </mat-form-field>

        <!-- Email -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Email ID</mat-label>
          <mat-icon matPrefix class="text-slate-500">email</mat-icon>
          <input matInput type="email" name="emailId" [(ngModel)]="l_formDataCustomer.emailId" email
            #emailId="ngModel" />
          <mat-error *ngIf="customerForm.submitted && emailId.invalid">
            Invalid Email ID
          </mat-error>
        </mat-form-field>

        <!-- Customer GST No -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Customer GST No</mat-label>
          <mat-icon matPrefix class="text-slate-500">receipt</mat-icon>
          <input matInput name="customerGstNo" [(ngModel)]="l_formDataCustomer.customerGstNo" maxlength="15"
            #customerGstNo="ngModel" />
          <mat-error *ngIf="customerForm.submitted && customerGstNo.invalid">
            Invalid GST No
          </mat-error>
        </mat-form-field>

        <!-- Active Checkbox -->
        <div class="md:col-span-1 flex items-center h-[56px]">
          <mat-checkbox name="isActive" [checked]="l_formDataCustomer.isActive === 'YES'"
            (change)="l_formDataCustomer.isActive = $event.checked ? 'YES' : 'NO'">
            <span class="text-[12px] font-semibold tracking-widest uppercase text-slate-700">
              Active
            </span>
          </mat-checkbox>
        </div>

        <!-- Buttons -->
        <div class="md:col-span-5 flex items-center justify-end h-[56px]">
          <div class="flex items-center gap-3">
            <button type="button" (click)="lFN_ResetForm(customerForm)" class="flex-1 md:flex-none px-6 py-2.5 rounded-lg
                    text-slate-500 text-[12px] font-medium tracking-widest uppercase
                    bg-slate-100 text-slate-900
                    transition-all duration-200">
              Reset
            </button>

            <button type="submit" class="px-4 py-2 rounded-md
                   bg-gradient-to-r from-slate-900 to-black
                   text-white text-[12px] font-medium tracking-widest uppercase
                   shadow hover:from-black hover:to-slate-800
                   transition-all duration-150 whitespace-nowrap">
              {{ isEditMode ? 'Update' : 'Save' }}
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>

  <!-- TABLE CARD -->
  <div class="bg-white rounded-lg shadow border border-slate-200 overflow-x-auto">

    <table mat-table [dataSource]="dataSource" class="w-full">

      <!-- Sr No -->
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef
          class="bg-gray-900 text-white uppercase text-xs text-center w-24 px-4 whitespace-nowrap">
          Sr No.
        </th>
        <td mat-cell *matCellDef="let row; let i = index" class="text-sm text-center px-4 whitespace-nowrap">
          {{ (paginator.pageIndex * paginator.pageSize) + i + 1 }}
        </td>
      </ng-container>

      <!-- Customer Name -->
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
          Customer Name
        </th>
        <td mat-cell *matCellDef="let c" class="text-sm px-4 whitespace-nowrap">
          {{ c.customerName }}
        </td>
      </ng-container>

      <!-- SMS Customer Name -->
      <ng-container matColumnDef="smsCustomerName">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
          SMS Customer Name
        </th>
        <td mat-cell *matCellDef="let c" class="text-sm px-4 whitespace-nowrap">
          {{ c.smsCustomerName }}
        </td>
      </ng-container>

      <!-- Primary Mobile -->
      <ng-container matColumnDef="primaryMobileNo">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
          Primary Mobile
        </th>
        <td mat-cell *matCellDef="let c" class="text-sm px-4 whitespace-nowrap">
          {{ c.primaryMobileNo }}
        </td>
      </ng-container>

      <!-- City -->
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
          City
        </th>
        <td mat-cell *matCellDef="let c" class="text-sm px-4 whitespace-nowrap">
          {{ c.city }}
        </td>
      </ng-container>

      <!-- Pincode -->
      <ng-container matColumnDef="pincode">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
          Pincode
        </th>
        <td mat-cell *matCellDef="let c" class="text-sm px-4 whitespace-nowrap">
          {{ c.pincode }}
        </td>
      </ng-container>

      <!-- Email -->
      <ng-container matColumnDef="emailId">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
          Email
        </th>
        <td mat-cell *matCellDef="let c" class="text-sm px-4 whitespace-nowrap">
          {{ c.emailId || '-' }}
        </td>
      </ng-container>

      <!-- GST No -->
      <ng-container matColumnDef="customerGstNo">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
          GST No
        </th>
        <td mat-cell *matCellDef="let c" class="text-sm px-4 whitespace-nowrap">
          {{ c.customerGstNo || '-' }}
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef
          class="bg-gray-900 text-white uppercase text-xs text-center px-4 whitespace-nowrap">
          Status
        </th>
        <td mat-cell *matCellDef="let c" class="text-center px-4 whitespace-nowrap">
          <button (click)="lFN_ChangeCustomerStatus(c)" class="w-20 text-center px-0 py-1.5 rounded-full
                 text-[10px] font-semibold tracking-widest uppercase
                 transition-all duration-200 border" [ngClass]="c.isActive === 'YES'
            ? 'bg-emerald-200 text-emerald-900 border-emerald-600 hover:bg-emerald-300'
            : 'bg-rose-200 text-rose-900 border-rose-600 hover:bg-rose-300'">
            {{ c.isActive === 'YES' ? 'Active' : 'Inactive' }}
          </button>
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef
          class="bg-gray-900 text-white uppercase text-xs text-center px-4 whitespace-nowrap">
          Actions
        </th>
        <td mat-cell *matCellDef="let c" class="text-center px-4 whitespace-nowrap">
          <button mat-icon-button (click)="lFN_EditCustomer(c)">
            <mat-icon class="text-black">edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <mat-paginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>

  </div>




</div>